import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errorText } from "@/lib/api";

export default function TeacherLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/docente" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/docente");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="mx-auto flex max-w-md flex-col px-5 py-16">
      <form onSubmit={submit} className="ink-box rise rounded-3xl bg-white p-8" data-testid="teacher-login-form">
        <span className="ink-box-sm flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--sun)]"><Lock className="h-5 w-5" /></span>
        <h1 className="font-display mt-5 text-3xl font-bold">Area docente</h1>
        <p className="mt-2 text-sm text-neutral-600">Accesso riservato agli insegnanti per gestire il glossario e generare contenuti con l'AI.</p>
        <label className="mt-6 block text-sm font-extrabold">Email</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" className="mt-1 w-full rounded-xl border-2 border-[var(--ink)] px-4 py-2.5 font-semibold outline-none focus:bg-[var(--paper)]" />
        <label className="mt-4 block text-sm font-extrabold">Password</label>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" className="mt-1 w-full rounded-xl border-2 border-[var(--ink)] px-4 py-2.5 font-semibold outline-none focus:bg-[var(--paper)]" />
        {error && <p className="mt-4 rounded-xl bg-red-100 px-3 py-2 text-sm font-bold text-red-700" data-testid="login-error">{error}</p>}
        <button disabled={busy} data-testid="login-submit-button" className="ink-box-sm ink-press mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[var(--sky)] py-3 font-extrabold text-white disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Entra
        </button>
      </form>
    </main>
  );
}
